import type { ItemTagCollection } from '@mattoespresso/brew-firestore';

import { useMemo, useContext, createContext } from 'react';
import { COLLECTIONS } from '@mattoespresso/brew-firestore';

import { useCollectionData } from 'src/hooks/useCollectionData';

const ProductTagsContext = createContext<{
  data: ItemTagCollection[];
  loading: boolean;
  error: any;
}>({
  data: [],
  loading: false,
  error: null,
});

export function useProductTags() {
  return useContext(ProductTagsContext);
}

export function ProductTagsProvider({ children }: { children: React.ReactNode }) {
  const { data, loading, error } = useCollectionData<ItemTagCollection>({
    collectionName: COLLECTIONS.itemTags,
  });

  const value = useMemo(
    () => ({
      data,
      loading,
      error,
    }),
    [data, loading, error]
  );

  return <ProductTagsContext.Provider value={value}>{children}</ProductTagsContext.Provider>;
}
